import { Card, Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

const ActionCard = ({ title, description, icon, color, path }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (!path) return;
    navigate(`/${path}`);
  };

  return (
    <Card
      hoverable
      style={{
        borderRadius: "12px",
        border: `2px solid ${color}`,
        transition: "all 0.3s ease",
        background: `${color}20`,
        height: '100%'
      }}
      styles={{
        body: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "10px 12px",
        },
      }}
      onClick={handleNavigate}
    >
      <Flex gap={10} vertical>
        {icon && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "8px",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: color,
                color: 'white',
                boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
              }}
            >
              {icon}
            </div>
          </div>
        )}

        <Title level={3} style={{ margin: 0, fontSize: '1.5rem' }} ellipsis={{ tooltip: true }}>
          {title}
        </Title>
      </Flex>

      <Paragraph
        style={{
          fontSize: '14px',
          lineHeight: "1.6",
          marginBottom: "auto",
        }}
        ellipsis={{ rows: 2, expandable: false }}
      >
        {description}
      </Paragraph>
    </Card>
  );
};

export default ActionCard;
